import {colors} from './colors';
import {scroll} from './scroll';
import {shadows} from './shadows';
import {spaces} from './spaces';
import {typography} from './typography';

export * from './colors';
export * from './scroll';
export * from './shadows';
export * from './spaces';
export * from './typography';

export const zIndex = {
  dropdown: 100,
  modal: 800,
  tooltip: 800,
  loader: 900,
  onboarding: 1000,
} as const;

// eslint-disable-next-line import/no-default-export
export default {colors, scroll, shadows, zIndex, spaces, typography};
